/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
class VariantPickerV2 {
  constructor() {
    const { variants } = window;
    if (!variants) throw new Error('variants have not been instantiated');

    const { getSelector, properties = [] } = variants;
    if (!getSelector) throw new Error('getSelector is not defined');
    if (!properties.length) throw new Error('properties are empty');

    this.selectors = properties.reduce((previous, current) => {
      const selector = variants.getSelector(current);
      if (!selector) throw new Error(`${current} selector was not found`);

      return ({ ...previous, [current]: selector });
    }, {});
  }

  getSelector(name) {
    const selector = this.selectors[name];
    if (!selector) throw new Error(`REGEN theme: ${name} selector was not found`);
    if (!selector.options) throw new Error(`${name} selector options are not defined`);
    return selector;
  }

  // Whether a selector exists for the given property. A property can be legitimately absent when it
  // was pruned as "no real value" (e.g. an N/A-only size), so callers should guard with this before
  // calling the strict getSelector/getSizeSelector/getConditionSelector accessors.
  hasSelector(name) {
    return Boolean(this.selectors[name]);
  }

  getSizeSelector() {
    return this.getSelector('size');
  }

  getConditionSelector() {
    return this.getSelector('condition');
  }
}
